/**
 * Hook to check if the current user has a pilot crew role
 * (JuniorPilot / SeniorPilot / LeadPilot) — gates flight log editing.
 */

import { isPilotRole } from '@@api/shared'
import { useCrewGetMe } from '@/lib/hooks'

/**
 * Check if current user is a pilot
 * @returns { isPilot: boolean; isLoaded: boolean }
 */
export function useIsPilot() {
  const { data: crew, isLoading } = useCrewGetMe()

  return {
    isPilot: isPilotRole(crew?.crewRole),
    isLoaded: !isLoading,
  }
}
